/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
import EmojiConvertor from 'emoji-js'

moment.locale('ja')

const KEY_LOGINUSER = 'LOGINUSER'
export interface TimesheetState {
  timesheets: any[]
  rangeTimesheets: any[]
  timezone: string
  offsetMin: number
  utctime: moment.Moment
  dates: any[]
  [key: string]: any;
}

const timesheet = defineModule({
  state: (): TimesheetState => {
    return {
      timesheets: [],
      rangeTimesheets: [],
      timezone: moment.tz.guess(),
      offsetMin: moment().utcOffset(),
      utctime: moment().utc(),
      dates: [],
    }
  },
  getters: {
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    },
  },
  actions: {
    async getMyTimesheet(context): Promise<any[]> {
      const { rootState, dispatch } = moduleActionContext(context, timesheet)
      var offsetMin = moment().utcOffset().toString();
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/getmytimesheet', "Failed to receive Timesheets", {offsetMin}, rootState.Login.accessToken)
      var timesheets = retval.data.data
      await dispatch.handleTimesheets({timesheets: timesheets, current: true});
      return timesheets
    },
    async handleTimesheets(context, payload:{timesheets: any; current: boolean}): Promise<any>{
      const { rootState, dispatch, commit } = moduleActionContext(context, timesheet)
      payload.timesheets.forEach((element: any) => {
        dispatch.getObjectReady(element)
      });
      commit.SET_VALUE({name: (payload.current ? 'timesheets' : 'rangeTimesheets'), value: payload.timesheets})
      var dates: any[] = []
      payload.timesheets.forEach((element: any) => {
        var found = false
        dates.forEach(date => {
          if (element.startedDate == date.startedDate) {
            date.timesheets.push(element)
            found = true
          }
        })
        if (!found) {
          let object = {
            startedDateDisp: element.startedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD (ddd)'),
            startedDate: element.startedDate,
            timesheets: [element],
            statusMessages: [],
            calendar: null
          }
          dates.push(object)
        }
      })
      dates.forEach(element => {
        element.duration = element.timesheets.reduce((total: number, element: any) => {
          return total + parseInt(element.dulationMin) 
        }, 0)
        element.total = (Math.floor(element.duration / 60)).toString() + ':' + (element.duration % 60).toString().padStart(2, '0') 
      })
      commit.SET_VALUE({name: 'dates', value: dates})
    },
    async getMyTimesheetWithStatus(context, {startDate, endDate}) : Promise<any>{
      const { rootState, dispatch, commit, state } = moduleActionContext(context, timesheet)
      var offsetMin = moment().utcOffset().toString();
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/getmytimesheetwithstatuscalendar', "Failed to receive Timesheets", {offsetMin, startDate, endDate}, rootState.Login.accessToken)
      var timesheets = retval.data.data.timesheets
      await dispatch.handleTimesheets({timesheets: timesheets, current: false});
      var statuses = retval.data.data.statusMessages
      var emoji = new EmojiConvertor()
      emoji.replace_mode = 'img'
      emoji.allow_native = false
      emoji.img_sets.apple.path = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@5.0.1/img/apple/64/'
      statuses.forEach((element: any) => {
        element.updatedGMTM = moment.tz(element.updatedAt, 'Etc/GMT')
        element.updatedDate = element.updatedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD')
        element.updatedTime = element.updatedGMTM.tz(moment.tz.guess()).format('HH:mm')
        if (rootState.Home.isPrivacyMode) {
          element.message = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
            return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
          }, element.message)
        }
        if (element.emojiName != null) {
          var emojiName = (element.emojiName != null && element.emojiName.length > 0 && element.emojiName[0] != ':') ? ':' + element.emojiName + ':' : element.emojiName
          if (element.emojiURL == null || element.emojiURL == "") {
            element.emoji = emoji.replace_colons(emojiName)
          } else {
            element.emoji = "<img width='24' height='24' src='" + element.emojiURL +  "'/>"
          }
        }
      })
      var calendars = retval.data.data.calendars;
      var workTypes = rootState.Calendar.workTypes
      calendars.forEach((element:any) => {
        var found = false
        element.dateOnly = moment(element.date).format('YYYY-MM-DD')
        element.isSameWorkType = element.tenantWorkTypeIdAM == element.tenantWorkTypeIdPM
        element.tenantWorkTypeIdAMOriginal = element.tenantWorkTypeIdAM
        element.tenantWorkTypeIdPMOriginal = element.tenantWorkTypeIdPM
        if (rootState.Home.isPrivacyMode) {
          element.plan = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
            return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
          }, element.plan)
        }
        element.approvals.forEach((ap: any) => {
          ap.postedGMTM = moment.tz(ap.postedGMT, 'Etc/GMT')
          ap.posted = ap.postedGMTM.tz(moment.tz.guess()).format('M/D ddd HH:mm')
          ap.status = ''
          if (ap.workTypeApprovedStatus==1){
            ap.status = '申請'
          }
          if (ap.workTypeApprovedStatus==2){
            ap.status = '許可済'
          }
          if (ap.workTypeApprovedStatus==3){
            ap.status = 'マネージャによって修正済'
          }
          if (ap.workTypeApprovedStatus==4){
            ap.status = '調整中'
          }
          if (ap.workTypeApprovedStatus==5){
            ap.status = '変更'
          }
          ap.isSameWorkType = ap.tenantWorkTypeIdAM == ap.tenantWorkTypeIdPM
          ap.AMName = workTypes.reduce((prev: string, current: any) => {
            if (current.tenantWorkTypeId == ap.tenantWorkTypeIdAM) { prev = prev + current.name }
            return prev
          }, '')
          ap.PMName = workTypes.reduce((prev: string, current: any) => {
            if (current.tenantWorkTypeId == ap.tenantWorkTypeIdPM) { prev = prev + current.name }
            return prev
          }, '')
          if (ap.isSameWorkType) {
            ap.workTypeName = '終日' + ap.AMName
          } else {
            ap.workTypeName = 'AM:' + ap.AMName + " PM:" + ap.PMName
          }
        })
        state.dates.forEach(date => {
          if (element.dateOnly == date.startedDate) {
            date.calendar = element
            found = true
          }
        })
        if (!found) {
          let object = {
            startedDateDisp: moment(element.date).format('YYYY-MM-DD (ddd)'),
            startedDate: element.dateOnly,
            timesheets: [],
            statusMessages: [],
            calendar: element
          }
          state.dates.push(object)
        }
      })
      state.dates.forEach(element => {
        element.duration = element.timesheets.reduce((total: number, element:any) => {
          return total + parseInt(element.dulationMin) 
        }, 0)
        element.total = (Math.floor(element.duration / 60)).toString() + ':' + (element.duration % 60).toString().padStart(2, '0')
        statuses.forEach((status: any) => {
          if (element.startedDate == status.updatedDate) {
            element.statusMessages.push(status)
          }
        })
      })
      commit.SET_VALUE({name: 'dates', value: state.dates})
      return {dates: state.dates, timesheets}
    },
    getObjectReady(context, element): Promise<any> {
      const { dispatch, rootState } = moduleActionContext(context, timesheet)
      element.startedGMTM = moment.tz(element.startedGMT, 'Etc/GMT')
      element.started = element.startedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm')
      element.startedShort = element.startedGMTM.tz(moment.tz.guess()).format('MM/DD dd HH:mm')
      element.startedDate = element.startedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD')
      element.startedTime = element.startedGMTM.tz(moment.tz.guess()).format('HH:mm')
      element.startedTime2 = element.startedGMTM.tz(moment.tz.guess()).format('HH:mm')
      element.startedClientM = moment(element.startedClient)
      element.startedClientF = element.startedClientM.format('YYYY-MM-DD HH:mm')
      element.endedGMTM = element.endedGMT == null ? null : moment.tz(element.endedGMT, 'Etc/GMT')
      element.ended = element.endedGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm')
      element.endedShort = element.endedGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('MM/DD dd HH:mm')
      element.endedDate = element.endedGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD')
      element.endedTime = element.endedGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('HH:mm')
      element.endedTime2 = element.endedGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('HH:mm')
      element.endedClientM = element.endedGMT == null ? null : moment(element.endedClient)
      element.endedClientF = element.endedGMT == null ? null : element.endedClientM.format('YYYY-MM-DD HH:mm')
      element.datemenu = false
      element.timemenu = false
      element.breakTimespanOriginal = element.breakTimespan
      element.commentOriginal = element.comment
      if (rootState.Home.isPrivacyMode) {
        element.comment = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
          return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
        }, element.comment)
      }    
      dispatch.CalcTotal(element)
      return element
    },
    async getMyTimesheetHistory(context, {startdate, enddate}): Promise<any> {
      const { rootState, dispatch } = moduleActionContext(context, timesheet)
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/getmytimesheet', "Failed to receive Timesheets", { startdate, enddate, pagesize: '1000' }, rootState.Login.accessToken)
      var timesheets = retval.data.data
      timesheets.forEach((element: any) => {
        dispatch.getObjectReady(element)
      });
      return timesheets
    },
    async getUserHistory(context, displayName): Promise<any>  {
      const { rootState, dispatch } = moduleActionContext(context, timesheet)
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/getuserhistory/' + displayName, "Failed to receive Timesheets", {}, rootState.Login.accessToken)
      var timesheets = retval.data.data
      timesheets.forEach((element: any) => {
        dispatch.getObjectReady(element)
      });
      return timesheets
    },
    async updateStarted(context, { TimesheetId, DateGMT, DateClient }): Promise<any>  {
      const { rootState, dispatch } = moduleActionContext(context, timesheet)
      var value = JSON.stringify({ DateGMT, DateClient })
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/update/' + TimesheetId, "Failed to update Timesheets Started", {Param: 'started', Value: value}, rootState.Login.accessToken)
      var element = retval.data.data
      dispatch.getObjectReady(element)
      return element
    },
    async updateEnded(context, { TimesheetId, DateGMT, DateClient }): Promise<any> {
      const { rootState, dispatch } = moduleActionContext(context, timesheet)
      var value = JSON.stringify({ DateGMT, DateClient })
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/update/' + TimesheetId, "Failed to update Timesheets Ended", {Param: 'ended', Value: value}, rootState.Login.accessToken)
      var element = retval.data.data
      dispatch.getObjectReady(element)
      return element
    },
    async updateBreakTimespan(context, { TimesheetId, BreakTimespan }): Promise<any> {
      const { rootState, dispatch } = moduleActionContext(context, timesheet)
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/update/' + TimesheetId, "Failed to update Timesheets Break", {Param: 'breaktimespan', Value: BreakTimespan}, rootState.Login.accessToken)
      var element = retval.data.data
      dispatch.getObjectReady(element)
      return element
    },
    async updateComment(context, { TimesheetId, Comment }): Promise<any> {
      const { rootState, dispatch } = moduleActionContext(context, timesheet)
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/update/' + TimesheetId, "Failed to update Timesheets Comment", {Param: 'comment', Value: Comment}, rootState.Login.accessToken)
      var element = retval.data.data
      dispatch.getObjectReady(element)
      return element
    },
    async startSession(context, ClientOffsetMin): Promise<any> {
      const { rootState } = moduleActionContext(context, timesheet)
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/start/' + ClientOffsetMin, "Failed to start Timesheets Session", {}, rootState.Login.accessToken)
      var element = retval.data.data
      return element
    },
    async endSession(context, ClientOffsetMin): Promise<any> {
      const { rootState } = moduleActionContext(context, timesheet)
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/end/' + ClientOffsetMin, "Failed to start Timesheets Session", {}, rootState.Login.accessToken)
      var element = retval.data.data
      return element
    },
    async delete(context, TimesheetId): Promise<any> {
      const { rootState } = moduleActionContext(context, timesheet)
      const retval = await Lib.Ajax.getHandleError<any>('/api/timesheet/delete/' + TimesheetId, "Failed to delete Timesheets", {}, rootState.Login.accessToken)
      var element = retval.data.data
      return element
    },
    async getMastersIfNeeded({dispatch, state}): Promise<any>{
      if (state.mastersUpdated == null) {
        await dispatch('getMasters')
      }
    },
    // eslint-disable-next-line no-empty-pattern
    CalcTotal({state}, item): any {
      item.dulation = null
      item.dulationMin = 0
      item.time = ''
      if (item.started == null || item.started == '') { return '----' }
      var start = item.startedGMTM
      var end = (item.ended == null || item.ended == '') ? moment() : item.endedGMTM
      var lunch = item.breakTimespan
      item.dulation = moment.duration(end.diff(start)).add(lunch * -1, 'minutes')
      item.dulationMin = Math.round(item.dulation.asMilliseconds() / 1000 / 60)
      var time = Math.floor(item.dulation.as('hours')) + ":" + item.dulation.minutes().toString().padStart(2, '0')
      item.total = time
      return time
    }
  },
  namespaced: true
})

export default timesheet
